import * as yup from 'yup';
import { schemaDefault } from '../../SchemaDefault';

export default {
  measure: schemaDefault.concat(
    yup
      .object()
      .shape({
        endTime: yup
          .number()
          .integer()
          .min(yup.ref('startTime'), 'endTime should be greater or equal then startTime')
          .required(),
        startTime: yup
          .number()
          .integer()
          .max(yup.ref('endTime'), 'startTime should be smaller or equal then endTime')
          .required(),
      })
      .strict(),
  ),
};
